export default __webpack_public_path__ + "static/media/Kristi_Godfrey_AHV_In_Moms_We_Trust.a41ff6c7.jpg";